import { fetchJsonWithDefaultHeaders, fetchWithDefaultHeaders } from 'common/http';
import { Attachment, Recurrence, ScheduleDeliverySubscription } from './ScheduleDeliveryAPI';

export function createScreenshotSubscription(
  partialSub: ScreenshotSubscriptionSansSubscriber,
  subscriberUid: string,
): SubscriptionResponse {
  const subscription = { ...partialSub, subscriber_uid: subscriberUid };
  return fetchWithDefaultHeaders('/api/notifications_and_alerts/screenshot_subscriptions', {
    method: 'POST',
    body: JSON.stringify({ subscription }),
  } as RequestInit);
}

export function fetchAllSubscriptionsForAsset(assetUid: string): SubscriptionListResponse {
  return fetchJsonWithDefaultHeaders(`/api/notifications_and_alerts/screenshot_subscriptions/${assetUid}`);
}

export function deleteAllForAsset(assetUid: string): EmptyResponse {
  return fetchWithDefaultHeaders(`/api/notifications_and_alerts/screenshot_subscriptions/${assetUid}`, {
    method: 'DELETE',
    credentials: 'same-origin',
  });
}

export function fetchAllSubscriptionsForUser(watching: boolean): SubscriptionListResponse {
  return fetchJsonWithDefaultHeaders(
    `/api/notifications_and_alerts/screenshot_subscriptions/?is_user_watching=${watching}`,
  );
}

type SubscriptionListResponse = Promise<SubscriptionListPayload>;
export type SubscriptionResponse = Promise<SingleSubscriptionPayload>;
type EmptyResponse = Promise<Response>;

export interface SubscriptionListPayload extends Response {
  data?: ScreenshotSubscription[] | ScheduleDeliverySubscription[];
}

interface SingleSubscriptionPayload extends Response {
  data?: ScreenshotSubscription;
}

export interface ScreenshotSubscription extends ScreenshotSubscriptionSansSubscriber {
  subscriber_uid: string;
}

interface ScreenshotSubscriptionSansSubscriber extends BaseScreenshotSubscriptionParameters {
  interval: Interval;
  creation_timezone?: string;

  // The existing watch record response already includes
  // scheduled delivery parameters below:
  attachments?: Attachment[] | null; // null if the record is an existing watch record
  last_occurrence?: string | null;
  schedule_name?: string | null;
  subject_line?: string | null;
  recurrence?: Recurrence;
}

export interface BaseScreenshotSubscriptionParameters {
  asset_uid: string;
  first_occurrence: string; // Date formatted as ISO string
  first_occurrence_timezone?: string;
  subscribed_by_uid: string;
  domain_cname?: string; // Optional due to changes in Scheduled Delivery
  domain_id?: number;
}

interface Interval {
  days: number;
}
